import type { ReactNode } from 'react';

/**
 * Calm, reusable fetch-error card for page-level query failures. Announces via
 * `role="alert"` and reuses the coral card treatment shared across surfaces.
 * Never surfaces a raw error message — pass friendly copy as children.
 */
export function FetchErrorCard({ children }: { children: ReactNode }) {
  return (
    <div
      role="alert"
      className="bg-[color-mix(in_oklab,var(--coral-400)_10%,transparent)] border border-[color-mix(in_oklab,var(--coral-400)_35%,transparent)] text-[var(--text-primary)] px-4 py-3 rounded-xl"
    >
      {children}
    </div>
  );
}
